import { lazy } from "react";
import { Route } from "react-router-dom";
const LibraryOverview = lazy(() => import("../../containers/model-library/Overview"));
const ModelComparison = lazy(() => import("../../containers/model-library/ModelComparison"));
const ModelDetailsPage = lazy(() => import("../../components/model-library/ModelDetails/ModelDetailsPage/ModelDetailsPage"));
export default function Key11Routes(key: string, link: string) {
	const key11Routes = [
		{ key: key, link: link + "/:tab", component: (props: any) => <LibraryOverview {...props} /> },
		{ key: key, link: link + "/models/model/", component: (props: any) => <ModelDetailsPage {...props} /> },
		{
			key: key,
			link: link + "/:tab?id=:id",
			component: (props: any) => <LibraryOverview {...props} />,
		},
		{ key: "1.1.1", link: link + "/", component: (props: any) => <LibraryOverview {...props} /> },
		{ key: "1.1.2", link: link + "/models/comparison", component: (props: any) => <ModelComparison {...props} /> },
	];
	return key11Routes.map((r) => <Route exact key={r.key} path={r.link} render={r.component} />);
}
